import DateHelper from '~/helpers/DateHelper';

export interface TrackerSettingAttributes {
  id: number,
  clientId: string,
  isLive: boolean,
  isPublished: boolean,
  defaultFieldValueType: string,
  defaultFieldValueText: string,
  extraFields?: Record<string, string> | null,
  createdAt: string,
  updatedAt?: string,
}

export interface TrackerSettingOperationAttributes {
  clientId?: string,
  isLive?: boolean,
  isPublished?: boolean,
  defaultFieldValueType: string,
  defaultFieldValueText: string,
  extraFields?: Record<string, string> | null,
}

export class TrackerSetting {
  constructor(private readonly attributes: TrackerSettingAttributes) {
  }

  get id(): number {
    return this.attributes.id;
  }

  get clientId(): string {
    return this.attributes.clientId;
  }

  get isLive(): boolean {
    return this.attributes.isLive;
  }

  get isPublished(): boolean {
    return this.attributes.isPublished;
  }

  get defaultFieldValueType(): string {
    return this.attributes.defaultFieldValueType;
  }

  get defaultFieldValueText(): string {
    return this.attributes.defaultFieldValueText;
  }

  get extraFields(): Record<string, string> | null | undefined {
    return this.attributes.extraFields;
  }

  get createdAt(): string {
    return this.attributes.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.attributes.updatedAt;
  }

  get lastModified(): string {
    return DateHelper.format(this.attributes?.updatedAt ?? this.attributes.createdAt);
  }
}
